export function renderClinicalTrust() {
  return `
    <section class="catalog-section" id="science" style="background: var(--color-bg-light); border-top: 1px solid var(--color-border-subtle);">
      <div class="calc-container">
        
        <div class="clinical-trust-grid">
          
          <div>
            <span class="badge badge-gold" style="margin-bottom: 14px;">Clinical Heritage • Established 1996</span>
            <h2 style="font-size: 2.25rem; font-weight: 800; color: var(--color-primary-navy); line-height: 1.25; margin-bottom: 18px;">
              Operating Continuously Since 1996: 30 Years of Documented Clinical Success Restoring Spine Health.
            </h2>
            
            <p style="font-size: 1rem; color: var(--color-text-muted); line-height: 1.7; margin-bottom: 16px;">
              In the early 1990s, Ukrainian gymnastics coach <strong>Vyacheslav Evminov</strong> suffered a catastrophic lumbar spinal injury. Facing multiple fusion surgeries with a low probability of ever walking normally again, he refused invasive operations and dedicated his life to spinal biomechanics.
            </p>

            <p style="font-size: 1rem; color: var(--color-text-muted); line-height: 1.7; margin-bottom: 20px;">
              By combining low-angle gravity traction with active kinetic muscle activation on an elastic wooden plane, he completely regenerated his damaged discs. <strong>Founded in 1996</strong>, the flagship <em>Evminov Vertebral Health Center</em> in central Kyiv has continuously operated for <strong>30 unbroken years</strong>, successfully helping over <strong>120,000 clinic patients</strong> and <strong>500,000+ home users worldwide</strong> recover from chronic herniations, sciatica, and postural collapse without surgery.
            </p>

            <div class="clinical-stats-grid">
              <div style="background: var(--color-surface-white); padding: 16px; border-radius: var(--radius-md); border: 1px solid var(--color-border-subtle); text-align: center;">
                <div style="font-family: var(--font-mono); font-size: 1.75rem; font-weight: 800; color: var(--color-pine-emerald);">
                  30 Yrs
                </div>
                <div style="font-size: 0.75rem; color: var(--color-text-muted); font-weight: 600;">Since 1996 Practice</div>
              </div>

              <div style="background: var(--color-surface-white); padding: 16px; border-radius: var(--radius-md); border: 1px solid var(--color-border-subtle); text-align: center;">
                <div style="font-family: var(--font-mono); font-size: 1.75rem; font-weight: 800; color: var(--color-traction-cyan);">
                  500k+
                </div>
                <div style="font-size: 0.75rem; color: var(--color-text-muted); font-weight: 600;">Patients Healed Globally</div>
              </div>

              <div style="background: var(--color-surface-white); padding: 16px; border-radius: var(--radius-md); border: 1px solid var(--color-border-subtle); text-align: center;">
                <div style="font-family: var(--font-mono); font-size: 1.75rem; font-weight: 800; color: var(--color-primary-navy);">
                  93.4%
                </div>
                <div style="font-size: 0.75rem; color: var(--color-text-muted); font-weight: 600;">Avoided Surgery</div>
              </div>
            </div>

            <!-- Youth Posture & Multi-Generational Family Ergonomics -->
            <div style="background: var(--color-surface-white); border: 1.5px solid var(--color-pine-border); border-radius: var(--radius-lg); padding: 18px; margin-bottom: 16px;">
              <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 6px; flex-wrap: wrap;">
                <span class="badge badge-cyan" style="font-size: 0.7rem; padding: 2px 8px;">Pediatric &amp; Family Ergonomics</span>
                <span style="font-size: 0.75rem; color: var(--color-pine-emerald); font-weight: 700;">Ages 4 to 85+ • 13.5 Sq Ft Footprint</span>
              </div>
              <div style="font-size: 0.9375rem; font-weight: 800; color: var(--color-primary-navy); margin-bottom: 6px;">
                Youth Scoliosis Prevention &amp; Natural Growth Unlock (+2–3 Inches)
              </div>
              <p style="font-size: 0.8125rem; color: var(--color-text-muted); line-height: 1.6; margin-bottom: 10px;">
                With 85%–90% of school-age children exhibiting postural asymmetry, a 5-minute daily playful routine de-rotates growing vertebrae, halts early scoliosis, and uncompresses epiphyseal growth plates to unlock up to 2–3 inches of natural genetic height.
              </p>
              <div style="background: rgba(16, 185, 129, 0.06); border-left: 3px solid var(--color-pine-emerald); padding: 8px 12px; border-radius: var(--radius-sm); font-size: 0.75rem; color: var(--color-primary-navy); font-style: italic;">
                "Physical exercise can replace many medications, but no medication can replace physical exercise." — Angelo Mosso, Italian Physiologist
              </div>
            </div>

            <!-- Center & Veteran Program Spotlight -->
            <div style="background: var(--color-surface-white); border: 1.5px solid var(--color-pine-border); border-radius: var(--radius-lg); padding: 20px; margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;">
              <div>
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <span class="badge badge-pine" style="font-size: 0.7rem; padding: 2px 8px;">Official Kyiv Flagship &amp; Branches</span>
                  <span style="font-size: 0.75rem; color: #D97706; font-weight: 700;">★ Defender Spine Program</span>
                </div>
                <div style="font-size: 0.9375rem; font-weight: 800; color: var(--color-primary-navy);">
                  Official Evminov Centers Network &amp; "Home Hospital" Model
                </div>
                <div style="font-size: 0.8125rem; color: var(--color-text-muted);">
                  9 Kostolna St, Kyiv • Glendale, CA • Frontline Combat Veteran Rehabilitation
                </div>
              </div>
              <a href="#centers" class="btn btn-primary btn-sm" style="white-space: nowrap;">
                View Centers &amp; History →
              </a>
            </div>

            <!-- Practitioner CTA -->
            <div style="background: var(--color-surface-white); border: 1.5px dashed var(--color-pine-border); border-radius: var(--radius-lg); padding: 18px; display: flex; align-items: center; justify-content: space-between; gap: 16px;">
              <div>
                <div style="font-size: 0.9375rem; font-weight: 800; color: var(--color-primary-navy);">
                  Are you a US Chiropractor or Physical Therapist?
                </div>
                <div style="font-size: 0.8125rem; color: var(--color-text-muted);">
                  Inquire about clinic demo boards & wholesale volume discounts.
                </div>
              </div>
              <a href="mailto:partners@evminovusa.com?subject=Chiropractic%20Clinic%20Inquiry" class="btn btn-secondary btn-sm" style="white-space: nowrap;">
                Practitioner Portal
              </a>
            </div>

          </div>

          <div class="clinical-photos-column" style="display: flex; flex-direction: column; gap: 20px;">
            <!-- Top Photo: Founder Vyacheslav Evminov & Patient Family in Kyiv Center -->
            <div style="position: relative; background: var(--color-surface-white); padding: 14px; border-radius: var(--radius-xl); box-shadow: var(--shadow-lg); border: 1px solid var(--color-border-subtle); overflow: hidden;">
              <div style="position: relative; overflow: hidden; border-radius: var(--radius-lg);">
                <img 
                  src="/images/authentic/vyacheslav-evminov-founder.jpg" 
                  alt="Vyacheslav Evminov, Master of Sports &amp; Founder of the Evminov Vertebral Center in Kyiv" 
                  style="width: 100%; height: 340px; object-fit: cover; object-position: center top; display: block;"
                />
                <div style="position: absolute; inset: 0; background: linear-gradient(180deg, rgba(11, 19, 43, 0.22) 0%, transparent 40%, rgba(11, 19, 43, 0.55) 100%); pointer-events: none;"></div>
                
                <span class="badge badge-gold" style="position: absolute; top: 12px; left: 12px; backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); background: rgba(217, 119, 6, 0.88); color: #FFFFFF; font-weight: 700; font-size: 0.75rem; border: 1px solid rgba(255,255,255,0.3); box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
                  Founder &amp; Method Creator
                </span>
                <span style="position: absolute; top: 12px; right: 12px; font-size: 0.72rem; font-weight: 700; color: #FFFFFF; background: rgba(11, 19, 43, 0.55); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); padding: 3px 9px; border-radius: var(--radius-full); border: 1px solid rgba(255,255,255,0.25);">
                  Kyiv Center • 1996
                </span>
                <div style="position: absolute; bottom: 12px; left: 14px; right: 14px; color: #FFFFFF; text-shadow: 0 1px 3px rgba(0,0,0,0.8);">
                  <strong style="font-size: 0.875rem; display: block; font-weight: 800;">Vyacheslav V. Evminov</strong>
                  <span style="font-size: 0.75rem; color: #E2E8F0; opacity: 0.95;">Honored Coach of Ukraine &amp; Pioneer of Kinetic Spine Traction</span>
                </div>
              </div>
            </div>

            <!-- Bottom Photo: Clinic Incline Traction Session with Transparent Quote Overlay -->
            <div style="position: relative; background: var(--color-surface-white); padding: 14px; border-radius: var(--radius-xl); box-shadow: var(--shadow-xl); border: 1px solid var(--color-border-subtle); overflow: hidden;">
              <div style="position: relative; overflow: hidden; border-radius: var(--radius-lg);">
                <img 
                  src="/images/authentic/clinic-rehab-center-1.jpg" 
                  alt="Official Evminov Spine Rehabilitation Center in Kyiv, Ukraine" 
                  style="width: 100%; height: 320px; object-fit: cover; object-position: center; display: block;"
                />
                
                <span class="badge badge-pine" style="position: absolute; top: 12px; left: 12px; backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); background: rgba(16, 185, 129, 0.85); color: #FFFFFF; font-weight: 700; font-size: 0.75rem; border: 1px solid rgba(255,255,255,0.3); box-shadow: 0 2px 8px rgba(0,0,0,0.2); z-index: 2;">
                  Active Vertebral Decompression
                </span>

                <!-- Translucent / Transparent Glassmorphic Quote Overlay (No heavy dark background) -->
                <div style="position: absolute; bottom: 14px; left: 14px; right: 14px; background: rgba(11, 19, 43, 0.38); backdrop-filter: blur(14px); -webkit-backdrop-filter: blur(14px); padding: 14px 18px; border-radius: var(--radius-md); border: 1px solid rgba(255, 255, 255, 0.25); color: #FFFFFF; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2); z-index: 2;">
                  <p style="font-style: italic; font-size: 0.875rem; line-height: 1.5; margin: 0; color: #F8FAFC; text-shadow: 0 1px 3px rgba(0,0,0,0.7);">
                    "Spinal health is not achieved through passive hanging or violent cracking. It requires gentle traction to create space, followed by micro-movements to feed the discs."
                  </p>
                  <div style="font-weight: 700; font-size: 0.775rem; color: #6EE7B7; margin-top: 6px; text-shadow: 0 1px 2px rgba(0,0,0,0.6);">
                    — Vyacheslav Evminov, Master of Sports &amp; Method Creator
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- The 3 Clinical Stages of Recovery Section (from evminov.com methodology) -->
        <div style="margin-top: 60px; padding-top: 48px; border-top: 1px solid var(--color-border-subtle);">
          <div style="text-align: center; max-width: 680px; margin: 0 auto 36px;">
            <span class="badge badge-pine" style="margin-bottom: 10px;">Clinical Methodology • Three Recovery Stages</span>
            <h3 style="font-size: 1.85rem; font-weight: 800; color: var(--color-primary-navy);">
              The Three Progressive Stages of Spinal Healing
            </h3>
            <p style="font-size: 0.95rem; color: var(--color-text-muted); line-height: 1.6;">
              Based on doctoral clinical research defended at leading Ukrainian medical academies, full spinal restoration requires a structured progression — never skipping directly to heavy load.
            </p>
          </div>

          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr)); gap: 24px;">
            
            <div class="card" style="background: var(--color-surface-white); border-radius: var(--radius-xl); padding: 28px; border: 1.5px solid var(--color-pine-border); display: flex; flex-direction: column; gap: 12px;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span class="badge badge-pine">Stage 01 • Weeks 1–3</span>
                <span style="font-family: var(--font-mono); font-size: 0.8125rem; font-weight: 700; color: var(--color-pine-emerald);">8°–15° Incline</span>
              </div>
              <h4 style="font-size: 1.2rem; font-weight: 800; color: var(--color-primary-navy); margin: 0;">
                Restorative &amp; Pain Relief
              </h4>
              <div style="font-size: 0.8125rem; color: #059669; font-weight: 700;">
                Stage 1: Restorative Decompression
              </div>
              <p style="font-size: 0.875rem; color: var(--color-text-muted); line-height: 1.6; margin: 0;">
                Gentle fractional gravitational traction decompresses nerve roots and relieves reflex muscle spasms. Negative intradiscal pressure triggers an osmotic pump, drawing fluid and nutrients back into dehydrated discs.
              </p>
            </div>

            <div class="card" style="background: var(--color-surface-white); border-radius: var(--radius-xl); padding: 28px; border: 1.5px solid var(--color-pine-border); display: flex; flex-direction: column; gap: 12px;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span class="badge badge-cyan">Stage 02 • Weeks 4–10</span>
                <span style="font-family: var(--font-mono); font-size: 0.8125rem; font-weight: 700; color: var(--color-traction-cyan);">15°–30° Incline</span>
              </div>
              <h4 style="font-size: 1.2rem; font-weight: 800; color: var(--color-primary-navy); margin: 0;">
                Paraspinal Muscular Corset
              </h4>
              <div style="font-size: 0.8125rem; color: #0284C7; font-weight: 700;">
                Stage 2: Core Strengthening &amp; Stabilization
              </div>
              <p style="font-size: 0.875rem; color: var(--color-text-muted); line-height: 1.6; margin: 0;">
                Under safe traction, patients perform low-amplitude micro-movement kinesitherapy to isolate and strengthen the deep short paraspinal rotatores and multifidus muscles, locking in newly regained intervertebral height.
              </p>
            </div>

            <div class="card" style="background: var(--color-surface-white); border-radius: var(--radius-xl); padding: 28px; border: 1.5px solid var(--color-pine-border); display: flex; flex-direction: column; gap: 12px;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span class="badge badge-gold">Stage 03 • Ongoing</span>
                <span style="font-family: var(--font-mono); font-size: 0.8125rem; font-weight: 700; color: #D97706;">5–10 Min / Day</span>
              </div>
              <h4 style="font-size: 1.2rem; font-weight: 800; color: var(--color-primary-navy); margin: 0;">
                Lifelong Prevention &amp; Habit
              </h4>
              <div style="font-size: 0.8125rem; color: #D97706; font-weight: 700;">
                Stage 3: Lifetime Maintenance &amp; Prevention
              </div>
              <p style="font-size: 0.875rem; color: var(--color-text-muted); line-height: 1.6; margin: 0;">
                A simple 5–10 minute daily habit replaces costly chiropractor sessions, counteracts the compressive strain of prolonged desk work and driving, and eliminates future relapse risk.
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  `;
}
